module.exports = __webpack_public_path__ + "img/bracket-square.00560288.svg";